import { Component, OnInit } from '@angular/core';

function aproposdefn() {
  alert("Bonjour !! \n\n Ceci est un mini-projet ISTIC pour le niveau LGLSI-2 en 2021 \n Réalisé par: Mohamed Dhia Jebali - Mariem Benjaballah - Aymen Tayari \n\n C'est une application web faite par angular pour la gestion des employés \n Vous pouvez ajouter, modifier, supprimer, chercher et consulter chaque employé dans la base de données de l'application");
}

function hoversoundfn() {
  var audio = new Audio('../assets/aud/cursor.ogg');
audio.play();
}

function clicksoundfn() {
  var audio = new Audio('../assets/aud/select.ogg');
audio.play();
}

async function backend_connecter_bd() {
  var eid = (document.getElementById("eid") as HTMLFormElement).value ;
  var motdepasse = (document.getElementById("motdepasse") as HTMLFormElement).value ;

  const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_connecter_bd?eid=${eid}&motdepasse=${motdepasse}`) ;   
  
  if (rep.ok){
    rep.json().then((data)=>{ 



      if (data.length != 0) {

        localStorage.setItem("connecteid",eid);
        localStorage.setItem("connectmdp",motdepasse);
        localStorage.setItem("connectnom",data[0].nom);

        if (data[0].admin == 1) {
          var audio = new Audio('../assets/aud/log.ogg');
          audio.play();
          alert("La connexion a réussi !\n\nBonjour "+data[0].nom+" !") ;
         
          
          window.location.href = '/accueiladmin' ;
        }


        if (data[0].admin == 0) {

          
          var audio = new Audio('../assets/aud/log.ogg');
          audio.play();
          alert("La connexion a réussi !\n\nBonjour "+data[0].nom+" !") ;
          
          window.location.href = '/accueilemploye' ;


        }

      }
      else {


        var audio = new Audio('../assets/aud/erreur.ogg');
        audio.play();
        alert("La connexion a échoué.\n\nAssurez-vous que les informations insérées sont correctes.")
      }

    }) 
  }

} ;

async function backend_tester_fn() {
  var eid = localStorage.getItem("connecteid");
  var motdepasse = localStorage.getItem("connectmdp");
  const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_connecter_bd?eid=${eid}&motdepasse=${motdepasse}`) ;   
  if (rep.ok){
    rep.json().then((data)=>{ 
      if (data.length != 0) {
        if (data[0].admin == 1) {
          window.location.href = '/accueiladmin' ;
        }
        if (data[0].admin == 0) {
          window.location.href = '/accueilemploye' ;
        }
      }
      else {
        localStorage.removeItem("connecteid");
        localStorage.removeItem("connectmdp");
        localStorage.removeItem("connectnom");
      }
    }) 
  } else {
    localStorage.removeItem("connecteid");
    localStorage.removeItem("connectmdp");
    localStorage.removeItem("connectnom");
  }
} ;


@Component({
  selector: 'app-connecter',
  templateUrl: './connecter.component.html',
  styleUrls: ['./connecter.component.css']
})
export class ConnecterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    backend_tester_fn()
  }

  aproposderun() {
    aproposdefn();
  }

  hoversound() {
    hoversoundfn();
  }

  clicksound() {
    clicksoundfn();
  }

  backend_connecter() {
    backend_connecter_bd() ;
  }



}
